module.exports = __webpack_public_path__ + "static/media/InitCall.75358c70.svg";